import api from "../../api/api";
import uploadAPI from "../../api/uploadAPI";
import axios from "axios";

import toast from "react-hot-toast";

export const ACTION_UPLOAD_TMP = "ACTION_UPLOAD_TMP";
export const ACTION_UPLOAD_LOCK = "ACTION_UPLOAD_LOCK";
export const ACTION_UPLOAD_COVER = "ACTION_UPLOAD_COVER";

export const ACTION_UPLOAD_TMP_PROCESS = "ACTION_UPLOAD_TMP_PROCESS";
export const ACTION_UPLOAD_TMP_DONE = "ACTION_UPLOAD_TMP_DONE";

export const ACTION_UPLOAD_LOCK_PROCESS = "ACTION_UPLOAD_LOCK_PROCESS";
export const ACTION_UPLOAD_LOCK_DONE = "ACTION_UPLOAD_LOCK_DONE";

export const ACTION_UPLOAD_COVER_PROCESS = "ACTION_UPLOAD_COVER_PROCESS";
export const ACTION_UPLOAD_COVER_DONE = "ACTION_UPLOAD_COVER_DONE";

export function tmpUpload(file) {
	return function (dispatch) {
		dispatch({ type: ACTION_UPLOAD_TMP_PROCESS });
		try {
			const formData = new FormData();
			formData.append("file", file);
			api
				.post("/tmp-upload/", formData, {
					headers: { "Content-Type": "multipart/form-data" },
				})
				.then((res) => {
					dispatch({
						type: ACTION_UPLOAD_TMP,
						payload: res.data,
					});
					dispatch({ type: ACTION_UPLOAD_TMP_DONE });
					toast.success("Successfully upload!");
				});
		} catch (error) {
			console.log(error);
			dispatch({ type: ACTION_UPLOAD_TMP_DONE });
			toast.error("Upload failed!");
		}
	};
}

export function coverUpload(file) {
	return function (dispatch) {
		dispatch({ type: ACTION_UPLOAD_COVER_PROCESS });
		try {
			const formData = new FormData();
			formData.append("file", file);
			api
				.post("/tmp-upload/", formData, {
					headers: { "Content-Type": "multipart/form-data" },
				})
				.then((res) => {
					dispatch({
						type: ACTION_UPLOAD_COVER,
						payload: res.data,
					});
					dispatch({ type: ACTION_UPLOAD_COVER_DONE });
					toast.success("Successfully upload!");
				});
		} catch (error) {
			console.log(error);
			toast.error("Upload failed!");
			dispatch({ type: ACTION_UPLOAD_COVER_DONE });
		}
	};
}

export function lockableFileUpload(file, buffer, owner) {
	return function (dispatch) {
		dispatch({ type: ACTION_UPLOAD_LOCK_PROCESS });
		try {
			const { name, type } = file;
			let keyFile;

			// const blob = new Blob([buffer], {
			// 	type: file.type,
			// });

			const form = new FormData();
			// form.append("asset", blob);
			form.append("name", name);
			form.append("type", type);

			axios
				.post(
					`${process.env.REACT_APP_API_LOCK_URL}/unlock/file-upload/${owner}`,
					form
				)
				.then((res) => {
					keyFile = res.data.key;
					uploadAPI
						.put(`${res.data.url}`, file, {
							headers: {
								"Content-Type": type,
								// "x-amz-acl": "public-read",
							},
						})
						.then((res) => {
							if (res.status === 200) {
								dispatch({ type: ACTION_UPLOAD_LOCK_DONE });
								toast.success("Successfully upload!");
								dispatch({
									type: ACTION_UPLOAD_LOCK,
									payload: { name: keyFile, type },
								});
							}
						});
				});
		} catch (error) {
			dispatch({ type: ACTION_UPLOAD_LOCK_DONE });
			toast.error("Upload failed!");
			console.log(error);
		}
	};
}

export const ACTION_UPLOAD_TMP_DELETE = "ACTION_UPLOAD_TMP_DELETE";
export const ACTION_UPLOAD_COVER_DELETE = "ACTION_UPLOAD_COVER_DELETE";
export const ACTION_UPLOAD_LOCK_DELETE = "ACTION_UPLOAD_LOCK_DELETE";

export function tmpDelete(tempName, target = "tmp") {
	return function (dispatch) {
		try {
			api.delete("/tmp-upload/" + tempName).then((res) => {
				console.log("delete res:", res);
			});
			dispatch({
				type:
					target === "lockable"
						? ACTION_UPLOAD_LOCK_DELETE
						: target === "tmp"
						? ACTION_UPLOAD_TMP_DELETE
						: ACTION_UPLOAD_COVER_DELETE,
			});
		} catch (error) {
			console.log(error);
		}
	};
}
